export default "__VITE_ASSET__A0b2JRIw__"